$.when(window.defFormLogic).done(function () {
    function getCookieGlobalDomain() { var a, b, c = "loanmartglobaldomaincookiename=cookie", d = document.location.hostname.split("."); for (a = d.length - 1; a >= 0; a--) if (b = d.slice(a).join("."), document.cookie = c + ";domain=." + b + ";", document.cookie.indexOf(c) > -1) return document.cookie = c.split("=")[0] + "=;domain=." + b + ";expires=Thu, 01 Jan 1970 00:00:01 GMT;", "." + b; return "" } Cookies.defaults.domain = getCookieGlobalDomain();
    var thirdPartyModalTimeOut = null;

    var appui = { form: {}, modal: {} };
    appui.form.$inputContainer = $('#getStartedForm');
    appui.form.$firstName = $('#firstName');
    appui.form.$lastName = $('#lastName');
    appui.form.$email = $('#email');
    appui.form.$state = $('#state');
    appui.form.$haveCar = $('#car');
    appui.form.$promoCode = $('#promocode');
    appui.form.$eSignConsent = $('#eSignConsent');
    appui.form.$sharingOfInfo = $('#sharingOfInfo');
    appui.form.$agreement = $('#estimate-widget-checkbox');
    appui.form.$submitBtn = $('#estimateLoanAmount');

    appui.modal.$modalContainer = $('#sfappModal');
    appui.modal.$visitPulBtn = $('#sfappBtnVisitPul');
    appui.modal.$backBtn = $('#sfappBtnBack');
    appui.modal.$thirdPartyContainer = $('#thirdPartyModal');

    appui.display = {};
    appui.display.$referToUrlBtn = $('#thirdPartyReferUrlBtn');
    appui.display.$thirdPartyCloseBtn = $(".third-party-close");
    appui.display.$thirdPartyState = $('.third-party-state');
    appui.display.$thirdPartyReferName = $('.thirdPartyReferName');
    appui.display.$thirdPartyDynamicText1 = $('.third-party-dynamic-text1');
    appui.display.$thirdPartyDynamicText2 = $('.third-party-dynamic-text2');
    appui.display.$thirdPartyDynamicText3 = $('.third-party-dynamic-text3');

    application.initialize();
    application.GetStates()
        .done(function (arr) {
            $.each(arr, function (index, item) {
                if (item)
                    $('<option />', { value: item.Value, text: item.Name }).appendTo(appui.form.$state);
            });
        });
   
    application.validPulStates = [];
    application.GetLoanStates('Pul')
        .done(function (arr) {
            if(arr){
                application.validPulStates = arr
            }
        });

    appui.form.$submitBtn.click(function (e) {
        e.preventDefault();
        
        var fv = appui.form.$inputContainer.data('formValidation');
        fv.validateContainer(appui.form.$inputContainer);
        var maxIterationCount = 15;
        var currentIteration = 0;

        waitForValidate();

        function waitForValidate() {
            setTimeout(function () {
                var isValidContainer = fv.isValidContainer(appui.form.$inputContainer);

                currentIteration++;
                if (isValidContainer === null && currentIteration < maxIterationCount) {
                    return waitForValidate();
                }

                if (isValidContainer) {

                    function applicationRedirect() {
                        var firstName = appui.form.$firstName.val();
                        var lastName = appui.form.$lastName.val();
                        var email = appui.form.$email.val();
                        var state = appui.form.$state.val();
                        var haveCar = appui.form.$haveCar.val();
                        var agree = appui.form.$agreement.is(":checked");
                        var eSignConsent = appui.form.$eSignConsent.is(":checked") ? 'true' : 'false';
                        var sharingOfInfo = appui.form.$sharingOfInfo.is(":checked") ? 'true' : 'false';
                        var promoCode = appui.form.$promoCode.val();

                        if (haveCar === 'yes') {
                            appui.form.$submitBtn.button('loading');

                            application
                                .GetLeadSaleDestinationInfo(state, "Ael")
                                .done(function (data) {
                                    if (data && data[0] && data[0].ReferToUrl) {
                                        appui.ReferToUrl = data[0].ReferToUrl;
                                        appui.ReferToName = data[0].ReferToName;

                                        if (appui.ReferToName.indexOf("TMG") > -1) {
                                            appui.display.$thirdPartyDynamicText1.text("our friends at ");
                                            appui.display.$thirdPartyDynamicText2.show();
                                            appui.display.$thirdPartyDynamicText3.text("apply with");
                                        } else if (appui.ReferToName.indexOf("Autotitleloans") > -1) {
                                            appui.display.$thirdPartyDynamicText1.text("");
                                            appui.display.$thirdPartyDynamicText2.hide();
                                            appui.display.$thirdPartyDynamicText3.text("go to");
                                        }

                                        application.LoanType = 'Unknown';
                                        var loanStateFullName = appui.form.$state.children(':selected').text();
                                        appui.display.$thirdPartyState.text(loanStateFullName);
                                        appui.display.$thirdPartyReferName.text(appui.ReferToName);
                                        appui.modal.$thirdPartyContainer.modal('show');

                                       thirdPartyModalTimeOut = window.setTimeout(function () {
                                           appui.display.$referToUrlBtn.click();
                                       }, 10000);

                                        return;

                                    } else {

                                        appui.ReferToUrl = "";
                                        appui.ReferToName = "";
                                        appui.modal.$thirdPartyContainer.modal('hide');

                                        var $duplicateleadModalContainer = $('#duplicateleadModal');
                                        $.ajax({
                                            url: globalSiteSettings.ddHandlerUrl + 'DDHandler.lmxd?a=validateduplicatelead',
                                            type: 'GET',
                                            data: { email: email },
                                            success: function (data) {
                                                data = JSON.parse(data);
                                                appui.form.$submitBtn.button('reset');
                                                if (!data[0].isDuplicate) {
                                                    $duplicateleadModalContainer.modal('hide');
                                                    SetCookiesAndSubmit();
                                                } else {
                                                    $duplicateleadModalContainer.modal('show');
                                                    return;
                                                }
                                            },
                                            error: function (xhr, textStatus, error) {
                                                appui.form.$submitBtn.button('reset');
                                                $duplicateleadModalContainer.modal('hide');
                                                SetCookiesAndSubmit();
                                            }
                                        });
                                    }
                                });


                        } else {
                            SetCookiesAndSubmit();
                        }

                        function SetCookiesAndSubmit() {
                            // Remove old cookies
                            document.cookie = 'sfapp.firstname=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.lastname=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.email=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.state=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.haveCar=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.promoCode=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.agree=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.eSignConsent=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp.sharingOfInfo=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'sfapp=' + ';path=/;domain='+Cookies.defaults.domain+';Expires=Thu, 01 Jan 1970 00:00:01 GMT;';

                            // Set new cross sub domain cookies
                            document.cookie = 'sfapp.firstname=' + firstName + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.lastname=' + lastName + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.email=' + email + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.state=' + state + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.haveCar=' + haveCar + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.promoCode=' + promoCode + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.agree=' + agree + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.eSignConsent=' + eSignConsent + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp.sharingOfInfo=' + sharingOfInfo + ';path=/;domain='+Cookies.defaults.domain;
                            document.cookie = 'sfapp=' + true + ';path=/;domain='+Cookies.defaults.domain;

                            var isValidRequestForPulApp = false;
                            if (haveCar && haveCar === 'no' && application.validPulStates) {
                                var resultStates = $.grep(application.validPulStates, function (e) {
                                    return e.Value === state;
                                });
                                isValidRequestForPulApp = resultStates.length === 1
                            }

                            if (isValidRequestForPulApp) {
                                appui.modal.$modalContainer.modal('show');
                            } else {
                                appui.modal.$modalContainer.modal('hide');
                                var appPhoneNumber = application.GetApplicationPhoneNumber();
                                var redirectPath = lm.constants.ApplicationUrl;

                                var selectedState = document.getElementById("state");
                                var nonServiceStates = ['FL', 'TN', 'IL', 'KY', 'IN', 'MI', 'MS', 'TX', 'SD', 'DE', 'OK', 'OR', 'OH', 'WA', 'KS', 'DC'];

                                //this checks to see if abtesturl is set, and if it is, use it 
                                //to determine where to redirect the end user
                                if(!nonServiceStates.indexOf(selectedState.value) !== -1 && "abtesturl" in window.lm.constants) {
                                    redirectPath = window.lm.constants.abtesturl;
                                }

                                if (appPhoneNumber !== "")
                                    window.location.href = redirectPath + "?phone=" + appPhoneNumber;
                                else {
                                    window.location.href = redirectPath;
                                }
                            }
                        }
                    }

                    function decodeUriComponentWithSpace(component) {
                        return decodeURIComponent(component.replace(/\+/g, '%20'));
                    }

                    // type : 'hash', 'search' or 'both'
                    function getLocationParameters(location, type) {
                        if ( type !== 'hash' && type !== 'search' && type !== 'both' ) {
                            throw 'getLocationParameters expect argument 2 "type" to be "hash", "search" or "both"';
                        }

                        var searchString = typeof location.search === 'undefined' ? '' : location.search.substr(1);
                        var hashString = typeof location.hash === 'undefined' ? '' : location.hash.substr(1);
                        var queries = [];
                        if ( type === 'search' || type === 'both' ) {
                            queries = queries.concat(searchString.split('&'));
                        }
                        if ( type === 'hash' || type === 'both' ) {
                            queries = queries.concat(hashString.split('&'));
                        }

                        var params = {};
                        var pair = void 0;

                        for ( var i = 0; i < queries.length; i++ ) {
                            if ( queries[i] !== '' ) {
                                pair = queries[i].split('=');
                                params[decodeUriComponentWithSpace(pair[0])] = decodeUriComponentWithSpace(pair[1]);
                            }
                        }

                        return params;
                    }

                    var urlSearchParams = getLocationParameters(window.location, 'both');
                    var sid = urlSearchParams.sid;
                    var uid = urlSearchParams.uid;
                    var postUrl = 'http://pearlhop.com/p.ashx?o=40&e=30&f=pb&r=' + uid + '&t=' + Math.floor((Math.random() * 999999999) + 1) + '-' + sid;

                    if ( sid || uid )
                    {
                        axios.post(postUrl)
                        .then(function(response) {

                            applicationRedirect();

                        })
                        .catch(function(error) {

                            window.debugLog('There was an error sending the pixel:', error);
                            applicationRedirect();

                        });
                    } else
                    {
                        applicationRedirect();
                    }

                }
            }, 100);
        }
    });

    appui.modal.$visitPulBtn.click(function (e) {
        e.preventDefault();

        var appPhoneNumber = application.GetApplicationPhoneNumber();
        if (appPhoneNumber !== "")
            window.location.href = globalSiteSettings.ddHandlerUrl + "/personal-loans/index.asp?phone=" + appPhoneNumber;
        else {
            window.location.href = globalSiteSettings.ddHandlerUrl + "/personal-loans/index.asp";
        }
    });

    appui.display.$referToUrlBtn.click(function () {
        if (appui.ReferToUrl) {
            // save loan lead, then redirect
            var firstName = appui.form.$firstName.val();
            var lastName = appui.form.$lastName.val();
            var email = appui.form.$email.val();
            var state = appui.form.$state.val();

            application.SaveLeadSaleLoanLead(firstName, lastName, email, state)
                .done(function (response) {
                    window.location.href = appui.ReferToUrl;
                });
        }
    });

    appui.display.$thirdPartyCloseBtn.click(function () {
        window.clearTimeout(thirdPartyModalTimeOut);
        appui.modal.$thirdPartyContainer.modal('hide');
        appui.form.$submitBtn.button('reset');
    });

    var choiceCashStates = ['FL', 'TN', 'IL', 'KY', 'IN', 'MI', 'MS', 'TX', 'SD', 'DE', 'OK', 'OR', 'OH', 'WA', 'KS', 'DC'];

    appui.form.$state.change(function(event) {

        if ( choiceCashStates.indexOf(this.value) !== -1 )
        {
            $('.lm-checkbox-container').css('display', 'none');
        } else if ( this.value == 'CA' )
        {
            $('.lm-checkbox-container').css('display', 'block');
        } else
        {
            $('.lm-checkbox-container').css('display', 'block');
            $('.ca-checkbox').css('display', 'none');
        }

    });

});
